import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from "./HeaderActions.module.css";
const headerActionsPropTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
export const HeaderActions = ({
  children,
  className
}) => {
  const classes = cx(styles.headerActions, className);
  return React.createElement("div", {
    className: classes
  }, children);
};
HeaderActions.propTypes = headerActionsPropTypes;
HeaderActions.__docgenInfo = {
  componentName: "HeaderActions",
  packageName: "@jutro/components",
  description: "HeaderActions",
  displayName: "HeaderActions",
  methods: [],
  actualName: "HeaderActions",
  metadataType: "container",
  props: {
    children: {
      type: {
        name: "node"
      },
      required: false,
      description: ""
    },
    className: {
      type: {
        name: "string"
      },
      required: false,
      description: ""
    }
  }
};